"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.padBboxToAspectRatio = padBboxToAspectRatio;
function padBboxToAspectRatio(bbox, maxAspectRatio) {
    const w = bbox.maxx - bbox.minx;
    const h = bbox.maxy - bbox.miny;
    if (w <= 0 || h <= 0) {
        return bbox;
    }
    if (w / h > maxAspectRatio) {
        const targetH = w / maxAspectRatio;
        const pad = (targetH - h) / 2;
        return { ...bbox, miny: bbox.miny - pad, maxy: bbox.maxy + pad };
    }
    if (h / w > maxAspectRatio) {
        const targetW = h / maxAspectRatio;
        const pad = (targetW - w) / 2;
        return { ...bbox, minx: bbox.minx - pad, maxx: bbox.maxx + pad };
    }
    return bbox;
}
//# sourceMappingURL=ModelBoundingBoxUtils.js.map